<button
  *ngIf="state$ | async as state"
  [class.-without-icon]="!state.hasIcon"
  [class.-without-label]="!state.hasTextContent || type === buttonType.Close"
  [class.-fixed]="fixed"
  [disabled]="disabled"
  class="a-button tw-w-full {{ buttonTypeClassesMap[type] }}"
  type="button"
>
  <ng-container *ngIf="type !== buttonType.Close">
    <span
      class="tw-flex"
      [class.tw-p-3]="state.hasIcon && !state.hasTextContent"
      [class.tw-py-3]="state.hasIcon && state.hasTextContent"
      [class.tw-pl-3]="state.hasIcon && state.hasTextContent"
      [class.tw-pr-2]="state.hasIcon && state.hasTextContent"
    >
      <ng-content select="[button-icon]"></ng-content>
    </span>

    <span *ngIf="state.hasTextContent" class="a-button__label">
      <ng-content></ng-content>
    </span>
  </ng-container>

  <bosch-ui-icon *ngIf="type === buttonType.Close" [name]="closeIcon" [isButtonIcon]="true"></bosch-ui-icon>
</button>
